import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";

interface StepperProps {
  currentStep: number;
}

export default function Stepper(props: StepperProps) {
  const { t } = useTranslation();

  const stepLabels = {
    1: t("home/web3/externalaccounts:stepper.profile"),
    2: t("home/web3/externalaccounts:stepper.bank"),
  };

  return (
    <View className="flex-row gap-3 p-2 w-fit items-center">
      <View className="w-8 h-8 border-2 border-purple1 p-1 items-center justify-center rounded-full">
        <Text className="text-purple1 font-bold text-lg">
          {props.currentStep.toString()}
        </Text>
      </View>
      <Text className="text-purple1 text-xl">
        {stepLabels[props.currentStep]}
      </Text>
    </View>
  );
}
